import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Püsiklient

  <span style="color:#85c1dc;">**FI:**</span>
  Kanta-asiakas

  <span style="color:#85c1dc;">**RU:**</span>
  Постоянный клиент
*/
/* @__NO_SIDE_EFFECTS__ */
const m657 = msg(
  mf`Püsiklient`,
  mf`Kanta-asiakas`,
  mf`Постоянный клиент`,
)

export { m657 as 'w.cart.table.client_price_col' }